<template>
    <div class="modal">
        <div class="modal-container" v-if="account">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Product Credits</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="w-full md:w-full">
                        <div class="account-body">
                            <div class="results-list">
                                <div class="results-row">
                                    <div class="results-head" data-width="60%">Product</div>
                                    <div class="results-head" data-width="40%">Credits</div>
                                </div>
                                <div class="results-row" v-for="(result, index) in groupedProductCredits" :key="index">
                                    <div class="results-cell" data-width="60%">{{ result[0].product.name }}</div>
                                    <div class="results-cell" data-width="40%">{{ result.length }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="left text-left">

                    </div>

                    <div class="middle text-middle">

                    </div>

                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AccountProductCreditsView',
        props: {
            account: {
                type: Object,
            },
        },
        components: {
            //
        },
        data() {
            return {
                //
            }
        },
        mounted() {
            this.loadData()

            this.setMetaTitle('Account Product Credits | JournoLink Control')
        },
        methods: {
            loadData () {
                //
            },
            /**
             * Emit the close event to the parent
             *
             * @return {void}
             */
            closeView() {
                this.$root.goBack()
            },
            /**
             * Handle an [Escape] keypress
             *
             * @return {void}
             */
            onEscapeKeypress() {
                this.closeView()
            },
        },
        computed: {
            /**
             * Determine if this account has product credits
             *
             * @return  {Boolean}
             */
            hasProductCredits() {
                return this.account.product_credits.length > 0
            },
            /**
             * Return the accounts product credits, grouped and counted
             *
             * @return  {Array}
             */
            groupedProductCredits() {
                return _.sortBy(
                    _.groupBy(this.account.product_credits, 'product_id'),
                    function (collection) {
                        return collection.length
                    }
                ).reverse()
            },
        },
    }
</script>

<style lang="less" scoped>
    .vdp-datepicker {
        display: inline-block;
        border: 1px solid #dddddd;
        padding: 5px;
    }

    .modal-body {
        h2, h3 {
            text-transform: uppercase;
            font-size: 1.2em;
            letter-spacing: .08em;
            color: #34495e;
            margin-bottom: 10px;
        }
    }

    p.note {
        margin: 10px 0;
        font-weight: bold;
    }
</style>
